import moment from "moment";
import {
  FILE_PREFIX_CODE,
  POST_SECTION_VALUES,
  AWS_URL,
} from "../config/constants";
import DefaultAvatar from "../common/DefaultAvatar";
import SimpleReactValidator from "simple-react-validator";
import {
  AMAZON_REGEX,
  INSTAGRAM_REGEX,
  REDDIT_REGEX,
  SNAPCHAT_REGEX,
  SPOTIFY_REGEX,
  TELEGRAM_REGEX,
  TIKTOK_REGEX,
  TWITCH_REGEX,
  TWITTER_REGEX,
  USERNAME_REGEX,
  YOUTUBE_REGEX,
} from "../config/regex";
import { toast } from "react-toastify";

function generateRandomFileName(prefix) {
  var timestamp = Date.now() + Math.floor(Math.random() * 100);
  if (prefix) {
    return FILE_PREFIX_CODE + "_" + prefix + "_" + timestamp;
  } else {
    return FILE_PREFIX_CODE + "_" + timestamp;
  }
}

function getFileExtension(file) {
  return file.type.split("/")[1].toLowerCase();
}

function formatTimeToSec(date) {
  //convert utc to local
  let yourDate = new Date(date);

  //format time as per figma
  const formattedTime = yourDate.toLocaleTimeString("en-US", {
    second: "numeric",
  });

  return formattedTime;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getReactionAndCommentCount(
  postEmojiLikesCount,
  valuePostEmojiCount,
  isInstantReaction,
  slug
) {
  const width = window.innerWidth;
  var isMobile = width <= 512;

  let TEXT = POST_SECTION_VALUES[slug];

  const currentCount = isInstantReaction
    ? postEmojiLikesCount
    : valuePostEmojiCount;
  if (currentCount === 0) {
    // return null;
    return `${currentCount} ${isMobile ? "" : TEXT.single}`;
  } else if (currentCount === 1) {
    return `${currentCount} ${isMobile ? "" : TEXT.single}`;
  } else if (currentCount > 1) {
    return `${currentCount} ${isMobile ? "" : TEXT.multiple}`;
  } else {
    return null;
  }
}

function calculateMinTime(date) {
  let isToday = moment(date).isSame(moment(), "day");
  if (isToday) {
    let nowAdd15Min = moment(moment().add(15, "minutes"));
    return nowAdd15Min;
  }
  return moment(date).startOf("day");
}

function calculateRate(a, b) {
  let result = a / b;
  return Number.isNaN(result)
    ? 0
    : Math.round((result * 100 + Number.EPSILON) * 100) / 100;
}

const timeClipComment = (inputDate, propsT, extendedWeek) => {
  const currentDate = new Date();
  const inputDateObj = new Date(inputDate);

  const timeDifferenceInMilliseconds = currentDate - inputDateObj;
  const secondsDifference = Math.floor(timeDifferenceInMilliseconds / 1000);

  if (secondsDifference < 1) {
    return propsT("clip.now");
  } else if (secondsDifference < 60) {
    return `${
      secondsDifference !== 1
        ? propsT("clip.secondsAgo", { secondsDifference })
        : propsT("clip.secondAgo")
    }`;
  } else {
    const minutesDifference = Math.floor(secondsDifference / 60);
    if (minutesDifference < 60) {
      return `${
        minutesDifference !== 1
          ? propsT("clip.minutesAgo", { minutesDifference })
          : propsT("clip.minuteAgo")
      }`;
    } else {
      const hoursDifference = Math.floor(minutesDifference / 60);
      if (hoursDifference < 24) {
        return `${
          hoursDifference !== 1
            ? propsT("clip.hoursAgo", { hoursDifference })
            : propsT("clip.hourAgo")
        }`;
      } else {
        const daysDifference = Math.floor(hoursDifference / 24);
        const extended = extendedWeek ? 14 : 7;
        if (daysDifference < extended) {
          return `${
            daysDifference !== 1
              ? propsT("clip.daysAgo", { daysDifference })
              : propsT("clip.dayAgo")
          }`;
        } else {
          const weeksDifference = Math.floor(daysDifference / 7);
          if (weeksDifference < 4) {
            // average days in a month
            return `${
              weeksDifference !== 1
                ? propsT("clip.weeksAgo", { weeksDifference })
                : propsT("clip.weekAgo")
            }`;
          } else {
            const monthsDifference = Math.floor(weeksDifference / 4);
            if (monthsDifference < 12) {
              return `${
                monthsDifference !== 1
                  ? propsT("clip.monthsAgo", { monthsDifference })
                  : propsT("clip.monthAgo")
              }`;
            } else {
              const yearsDifference = Math.floor(monthsDifference / 12);
              return `${
                yearsDifference !== 1
                  ? propsT("clip.yearsAgo", { yearsDifference })
                  : propsT("clip.yearAgo")
              }`;
            }
          }
        }
      }
    }
  }
};

const stringAvatar = (name) => {
  if (name) {
    name = name.toUpperCase();
    return {
      children: `${name.split(" ")[0][0]}${
        name.split(" ")[1] ? name.split(" ")[1][0] : ""
      }`,
    };
  } else {
    return {
      children: null,
    };
  }
};

const isNotValid = (value) => {
  return value === undefined || value === null;
};

const getCoverPic = (userId, coverImage, addUrlCssTag) => {
  let urlCoverPic = AWS_URL + "users/" + userId + "/cover_image/" + coverImage;

  if (addUrlCssTag) {
    urlCoverPic = "url(" + urlCoverPic + ")";
  }

  return urlCoverPic;
};

const getUserProfilePic = (
  userId,
  pictureName,
  addUrlCssTag,
  extraParameters
) => {
  let urlProfilePic =
    AWS_URL + "users/" + userId + "/profile_pic/" + pictureName;

  if (addUrlCssTag) {
    urlProfilePic = "url(" + urlProfilePic + ")";
  }

  if (extraParameters) {
    urlProfilePic = urlProfilePic + " " + extraParameters;
  }
  if (userId) {
    return urlProfilePic;
  } else {
    return null;
  }
};

const ProfilePicture = (props) => {
  var imageURL = props.profilePicture
    ? getUserProfilePic(props.id, props.profilePicture)
    : null;
  return (
    <DefaultAvatar id={props.id} userName={props.name}>
      {props.profilePicture ? (
        <img
          alt=""
          style={{
            height: "36px",
            width: "36px",
            borderRadius: "99px",
            background: "white",
          }}
          src={imageURL}
        ></img>
      ) : null}
    </DefaultAvatar>
  );
};

const charCount = (text, maxLength) => {
  return (text ? text.length : 0) + "/" + maxLength;
};

const hasWhiteSpace = (s) => {
  return /\s/g.test(s);
};

const truncateLongNameUserName = (text) => {
  if (!hasWhiteSpace(text)) {
    var truncated = text.substring(0, 22) + "...";
    return text.length > 22 ? truncated : text;
  } else {
    return text;
  }
};

/**
 * Creates a regex-based validator for SimpleReactValidator
 * @param {string} messageKey - Translation key for error message
 * @param {RegExp} regex - Regex pattern to validate against
 * @param {Function} t - Translation function
 * @returns {Object} Validator config object
 */
const createRegexValidator = (messageKey, regex, t) => ({
  message: t(messageKey),
  rule: (val) => Boolean(val.match(regex)),
});

const AccountValidator = (object, t) => {
  return new SimpleReactValidator({
    className: "text-danger",
    autoForceUpdate: object,
    validators: {
      instagram_validate: createRegexValidator("account.form.instagram.validator", INSTAGRAM_REGEX, t),
      twitter_validate: createRegexValidator("account.form.twitter.validator", TWITTER_REGEX, t),
      snapchat_validate: createRegexValidator("account.form.snapchat.validator", SNAPCHAT_REGEX, t),
      reddit_validate: createRegexValidator("account.form.reddit.validator", REDDIT_REGEX, t),
      telegram_validate: createRegexValidator("account.form.telegram.validator", TELEGRAM_REGEX, t),
      twitch_validate: createRegexValidator("account.form.twitch.validator", TWITCH_REGEX, t),
      youtube_validate: createRegexValidator("account.form.youtube.validator", YOUTUBE_REGEX, t),
      amazon_validate: createRegexValidator("account.form.amazon.validator", AMAZON_REGEX, t),
      tiktok_validate: createRegexValidator("account.form.tiktok.validator", TIKTOK_REGEX, t),
      spotify_validate: createRegexValidator("account.form.spotify.validator", SPOTIFY_REGEX, t),
      username_validate: createRegexValidator("account.form.username.validator", USERNAME_REGEX, t),
    },
  });
};

const handleShareProfile = (username) => {
  let shareData = {
    title: "RedCircle",
    text: "The most rewarding interaction ever.",
    url: process.env.REACT_APP_BASEURL + "" + username,
  };
  navigator.share(shareData);
};

const copyAction = (userName, postId, t) => {
  let url = process.env.REACT_APP_BASEURL + "post-detail?id=" + postId;
  navigator.clipboard.writeText(url);
  toast.success(t("creatorProfile.linkCopied"));
};

export {
  generateRandomFileName,
  getFileExtension,
  formatTimeToSec,
  capitalizeFirstLetter,
  getReactionAndCommentCount,
  calculateMinTime,
  calculateRate,
  timeClipComment,
  stringAvatar,
  isNotValid,
  getUserProfilePic,
  ProfilePicture,
  getCoverPic,
  charCount,
  truncateLongNameUserName,
  hasWhiteSpace,
  AccountValidator,
  createRegexValidator,
  handleShareProfile,
  copyAction,
};
